import React, { createContext, useContext, useState } from 'react';
import { SUB_PANEL_SORTING } from 'Monitoring/subPanels/tags/constants';
import { LocalStorageKeys } from 'Utils/localStorage';
// -- sorting by persist
const setStoredSortingBy = (sortBy) => {
    localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_SORTING_BY, JSON.stringify(sortBy));
};
const getStoredSortingBy = () => JSON.parse(localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_SORTING_BY));
// Context
const TagsPanelSortingContext = createContext(null);
// Provider Component
const TagsPanelSortingProvider = ({ children }) => {
    const [tagsPanelSortingBy, setTagsPanelSortingBy] = useState(getStoredSortingBy() || SUB_PANEL_SORTING.CONTRIBUTION_LAST_3_DAYS);
    // Handlers
    const handleSetTagsPanelSortingBy = (sortBy) => {
        setTagsPanelSortingBy(sortBy);
        setStoredSortingBy(sortBy);
    };
    // Render
    return (React.createElement(TagsPanelSortingContext.Provider, { value: {
            tagsPanelSortingBy,
            onSetTagsPanelSortingBy: handleSetTagsPanelSortingBy
        } }, children));
};
// Custom Hook
export const useTagsPanelSorting = () => useContext(TagsPanelSortingContext);
export default TagsPanelSortingProvider;
